import React, { Component } from 'react'
import { Input, InputGroup, Icon,CheckboxGroup,Checkbox,RadioGroup,Radio } from 'rsuite';

import Config from '../../config/Config'
import Cache from '../../frame/Cache';
import WidgetAjax from '../../widget/WidgetAjax';
import WidgetModal from '../../widget/WidgetModal';
import WidgetTreeTable from '../../widget/WidgetTreeTable';
import WidgetMessage from '../../widget/WidgetMessage';
import WidgetComponent from '../../widget/WidgetComponent';
import WidgetTable from '../../widget/WidgetTable';
import WidgetSelect from '../../widget/WidgetSelect';

import 'antd/dist/antd.css';

class Uims extends Component {

    constructor( props )
    {
        super(props);

        let path = Config.getBasePath();

        if( path.endsWith('/')===false )
        {
            path = path + '/';
        }
        this.state = {
            path : path,
            keyWord : undefined,
            data : undefined,
            total : undefined,
            options : {
                // 数据条数
                records : 10
            },
            columns:[
                { name: 'id', title: '接口id', type: 'string', description: '接口id', properties: { hidden: true }},
                { name: 'title', title: '接口标题', type: 'string', description: '接口标题', properties: { hidden: false }},
                { name: 'name', title: '接口名称', type: 'string', description: '接口名称', properties: { hidden: false }},
                { name: 'type', title: '接口类型', type: 'string', description: '接口类型', properties: { hidden: false }},
                { name: 'path', title: '接口路径', type: 'string', description: '接口路径', properties: { hidden: false }},
                { name: 'accessName', title: '接口操作权限', type: 'string', description: '接口操作权限', properties: { hidden: false }},
                { name: 'description', title: '接口内容', type: 'string', description: '接口内容', properties: { hidden: false }},
                { name: 'operation', title: '操作', type: 'string', description: '操作', 
                    properties: {hidden: false, 
                        operations: [
                            { name: '编辑', click: "edit" },
                            { name: '删除', click: "remove" },
                        ]
                    }
                },
              
            ],
            adddata :[],
            editRroupModelOptions : {
                title : "新增组件",
                confirm : "确定",
                size:'md'
            },
            Group : {},
            removeGroup : {},
            layout : {
                labelCol: { span: 6 },
                wrapperCol: { span: 16 },
            },
            messageOptions : {
                title : "信息",
            },
            typeOptions:{
                title:'组件类型'
            },
            
            typesData:[
                {"label":"PAGE", "value":"PAGE"},
                {"label":"WIDGET", "value":"WIDGET"},
            ],

            defaultValue : 3,
            editComponentModelOptions : {
                title : "编辑",
                confirm : "确定",
                size:'md'
            },
            editData:{},
            isCreate:true,
            typeData:[
                {"label":"USER", "value":"USER"},
                {"label":"SYSTEM", "value":"SYSTEM"},
                {"label":"SECURITY", "value":"SECURITY"},
                {"label":"WIDGET", "value":"WIDGET"},
                {"label":"SERVICE", "value":"SERVICE"}
            ],
        };
        this.cnewly=this.cnewly.bind(this)
        this.onEvent = this.onEvent.bind(this);
        this.pageTurning = this.pageTurning.bind(this);
        this.componentRemove = this.componentRemove.bind(this);
        this.keyWordKeyUp = this.keyWordKeyUp.bind(this);
        this.removeConfirm = this.removeConfirm.bind(this);
        // this.csubmitProperty=this.csubmitProperty.bind(this)
        this.keyWordOnChange = this.keyWordOnChange.bind(this);
        this.onRemoveGroup = this.onRemoveGroup.bind(this); 
        this.searchMethod = this.searchMethod.bind(this);
        this.onsearchMethod = this.onsearchMethod.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.inputOnchange = this.inputOnchange.bind(this);
        this.onEditSelect = this.onEditSelect.bind(this);
        this.createMethods = this.createMethods.bind(this);
        this.AddMethods = this.AddMethods.bind(this);
        this.onAddMethods = this.onAddMethods.bind(this);
    }

    componentDidMount()
    {
        this.searchMethod();
    }

    /**
     * 表格点击事件
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @param {*} event 
     */
     onEvent(type, data, value, event)
     {
         if( data!==undefined )
         {
             data = JSON.parse(data);
         }
 
         switch( type )
         {
             case "edit":
             {
                 this.setState({editData:data, isCreate:false})
                 this.addComponent.open();
                 break;
             }
             case "remove":
            {
                this.componentRemove(data)
                break;
            }
             default:
                 break;
         }
     }

    //创建接口
    createMethods()
    {
        this.setState({editData:{},isCreate:true},()=>{
            this.addComponent.open();
        })
    }

    //编辑&添加
    AddMethods()
    {
        let { isCreate, editData, path, messageOptions } = this.state,params = {},access = 0;
        
        //各个选项的非空校验
        if(editData.title === "" || editData.title === undefined || editData.title === null)
        {
            messageOptions.isMessage = true;
            messageOptions.message = "接口标题不能为空！";
            this.setState({messageOptions},()=>{
                this.messageRef.open()
            })
            return;
        }
        else if(editData.name === "" || editData.name === undefined || editData.name === null)
        {
            messageOptions.isMessage = true;
            messageOptions.message = "接口名称不能为空！";
            this.setState({messageOptions},()=>{
                this.messageRef.open()
            })
            return;
        }
        else if(editData.type === "" || editData.type === undefined || editData.type === null)
        {
            messageOptions.isMessage = true;
            messageOptions.message = "请选择接口类型！";
            this.setState({messageOptions},()=>{
                this.messageRef.open()
            })
            return;
        }
        else if(editData.path === "" || editData.path === undefined || editData.path === null)
        {
            let paths = /^[a-zA-Z]:(([a-zA-Z]*)||([a-zA-Z]*\\))*/;

            if(paths.test(editData.path)){

            }
            messageOptions.isMessage = true;
            messageOptions.message = "接口路径不能为空！";
            this.setState({messageOptions},()=>{
                this.messageRef.open()
            })
            return;
        }
        else if(editData.accessType === [] || editData.accessType === undefined || editData.accessType === null)
        {
            messageOptions.isMessage = true;
            messageOptions.message = "请选择接口权限！";
            this.setState({messageOptions},()=>{
                this.messageRef.open()
            })
            return;
        }

        editData.accessType.forEach((val,index)=>{
            access+=val
        })

        

        params = {
            type:editData.type,
            name:editData.name,
            title:editData.title,
            captchar:editData.captchar?editData.captchar:false,
            description:editData.description,
            access
        }

            let filter =  /[^\u0000-\u00FF]/

            if(!filter.test(editData.path)){
                params["path"] = editData.path
            }else{

                messageOptions.isMessage = true;

                messageOptions.message = "请输入正确路径！";

                this.setState({messageOptions},()=>{
                    this.messageRef.open()
                })
    
                return ;
            }



        if(isCreate)
        {
            WidgetAjax.ajax({url:path+'method/create', params:params, callback:this.onAddMethods, backParams:params})
        }
        else
        {
            params["id"] = editData.id;

            WidgetAjax.ajax({url:path+'method/update', params:params, callback:this.onAddMethods, backParams:params});
        }
    }
 
    //编辑&添加 的回调函数
    onAddMethods( result, backParams )
    {
        let { isCreate, messageOptions } = this.state;
        if( result.status===0 )
        {
            if(isCreate)
            {
                messageOptions["title"] = "新增接口";
                messageOptions["isMessage"] = true;
                messageOptions["message"] = "接口 " + backParams.name + " 新增成功!";
                this.setState({messageOptions},()=>{
                    this.messageRef.open();
                })

               
            }
            else
            {
                messageOptions["title"] = "编辑接口";
                messageOptions["isMessage"] = true;
                messageOptions["message"] = "接口 " + backParams.name + " 编辑成功!";
                this.setState({messageOptions},()=>{
                    this.messageRef.open();
                })
            }

            this.searchMethod();

            setTimeout(() => {
                this.props.history.go()
            }, 1500);
        }
        else if( result.status===10 ) 
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 删除角色
     * @param {*} data 
     */
     componentRemove( data )
    {

        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false ;
        messageOptions["message"] = `确定要删除接口 '` + data.name +`' 吗? 删除后将不能恢复！` ;
        messageOptions["confirmFunction"] = this.removeConfirm;
        
        this.state["removeData"] = data;

        this.state["messageOptions"] = messageOptions;

        this.messageRef.open();
    }

    /**
     * 删除确认函数
     */
    removeConfirm()
    {
        const { path, removeData } = this.state;

        if( removeData!==undefined )
        {
            let params = {
                id : removeData.id
            }
    
            WidgetAjax.ajax({ url:path + 'method/remove', params:params, callback:this.onRemoveGroup });
        }
    }

    /**
     * 删除回调函数
     * @param {*} result 
     * @param {*} params 
     */
    onRemoveGroup( result )
    {
        let { removeData, messageOptions } = this.state;

        if( result.status===0 )
        {
            messageOptions["title"] = "删除接口";
            messageOptions["isMessage"] = true;
            messageOptions["message"] = "接口 " + removeData.name + " 删除成功!";

            this.setState({messageOptions},()=>{
                this.messageRef.open();
            })

            // this.searchMethod(1);
            setTimeout(() => {
                this.props.history.go()
            }, 1500);
        }
        else if( result.status===10 ) 
        {
            Cache.logout(this.props);
        }

    }


    // 下拉菜单的select
    onEditSelect(value, item, event)
    {
        this.state["editData"] = {...this.state.editData,type:value}
    }
    
    // 下拉菜单的select
    onSelect(value, item, event)
    {
        this.setState({defaultValue:value});
        if(value){
            this.keyWordOnChange(value,'keyword') // 调用搜索接口
        }else{  
            this.setState({keyWord: undefined}, () => {
                this.searchMethod()
            });
        }
    }

    /**
     * 搜索关键字变化回调函数 
     * @param {*} value 
     * @param {*} event 
     */
    keyWordOnChange( value,type)
    {
        switch( type )
        {
            case "keyword":
            {
                this.setState({keyWord:value},()=>{
                    this.searchMethod()
                });
                break;
            }

            case "keywords":
            {
                if(value === "" || value === null || value === undefined)
                {
                    this.setState({keyWord:value},()=>{
                        this.searchMethod()
                    });
                }
                else
                {
                    this.setState({keyWord:value});
                }
                break;
            }
             
            default:
                break;
        }
    }

    /**
     * 键盘事件捕获
     * @param {*} e 
     */
    keyWordKeyUp( e )
    {
        /** 判断是否是回车事件 */
        if( e.keyCode===13 )
       {
            this.searchMethod();
       }    
    }

    /**
     * 组件搜索函数
     */
    searchMethod(page = 1 )
    {
        let { path, keyWord, options } =this.state,
            params = {};

        params["page"] = page
        params["records"] = 10

        if(keyWord != undefined)
        {
            params["name"] = keyWord;
        }


        WidgetAjax.ajax({url:path+'method/search', params:params, callback:this.onsearchMethod})
    }

    onsearchMethod(result,params)
    {
        if(result.status===0)
        {
            let data = result.results;

            data.forEach(( val, item )=>{
                switch(val.access)
                {
                    case 0 :
                        {
                            val.accessName = "无";
                            val.accessType = []
                            break;
                        }
                    case 1 :
                        {
                            val.accessName = "读";
                            val.accessType = [1]
                            break;
                        }
                    case 2 :
                        {
                            val.accessName = "写";
                            val.accessType = [2]
                            break;
                        }
                    
                    case 3 :
                        {
                            val.accessName = "读、写";
                            val.accessType = [1,2]
                            break;
                        }
                    case 4 :
                        {
                            val.accessName = "执行";
                            val.accessType = [4]
                            break;
                        }
                    case 5 :
                        {
                            val.accessName = "读、执行";
                            val.accessType = [1,4]
                            break;
                        }
                    case 7 :
                        {
                            val.accessName = "读、写、执行";
                            val.accessType = [1,2,4]
                            break;
                        }
                }
            })
            this.setState({data:data,total:result.total})
        } 
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        } 
    }
    // 新增中新增属性的单击事件
    cnewly(){
        this.caddPropety.open()
    }

        /**
     * 表格翻页
     * @param {*} page 
     */
    pageTurning( page )
    {
        this.searchMethod(page);
    }

    inputOnchange(value, type)
    {
        switch(type)
        {
            case "ctitle":
                this.state["editData"] = {...this.state.editData, title:value}
            break;

            case "cname":
                this.state["editData"] = {...this.state.editData, name:value}
            break;

            case "path":
                this.state["editData"] = {...this.state.editData, path:value}
            break;
            case "cradios":
                this.state["editData"] = {...this.state.editData, captchar:value}
            break;
            case "coperation" :
                this.state["editData"] = {...this.state.editData, accessType:value};
            break;
            case "description" :
                this.state["editData"] = {...this.state.editData, description:value};
            break;
            default:
            break;
        }
    }


    /**
     * 把子组件注入到父主键里
     * @param {*} ref 
     */
     addComponent = (ref) => {

        this.addComponent =  ref ;
    }

    messageRef = ( ref ) => {
        this.messageRef = ref;
    }

    caddPropety = (ref) => {
        this.caddPropety=ref
    }

    render() 
    {
        const { columns, data, total, keyWord, options, editRroupModelOptions, messageOptions, typeOptions, defaultValue,
            editComponentModelOptions, editData, typeData} = this.state;

        editRroupModelOptions["confirmFunction"] = this.submitComponent;
        editComponentModelOptions["confirmFunction"] = this.AddMethods;

        return (
            <div className="page">
                {/* <div className="page-weidu">
                    <div className="page-title">
                        <div className="page-title-img"><img src={require("./img/ml-ztzt.png")} alt=""></img></div>
                        <span className="page-title-font">接口管理</span>
                    </div>
                </div> */}
                
                <div className="page-content page-overflow" style={{height:"100%"}}>
                    <div className="content-canvas content-top-frame-height height-100">
                        <div className="content-title Addroles component-type" style={{padding:"0 16px"}}>

                            <div className="button" onClick={this.createMethods}>
                                <span className="addUser click">新增接口</span>
                            </div>
                        
                            <div className="search">
                                <InputGroup className="InputGroup">
                                    <Input name="Serchkey"  defaultValue={keyWord} placeholder="请输入搜索内容" onChange={(value)=>(this.keyWordOnChange(value,'keyword'))} onKeyUp={this.keyWordKeyUp} />
                                    <InputGroup.Addon><Icon icon="search" /></InputGroup.Addon>
                                </InputGroup>
                            </div>
                        </div>

                        <div className="content-chart-height content-table">
                            <WidgetTable options={options} columns={columns} data={data} total={total} notify={this.onEvent} pageTurning = {this.pageTurning}></WidgetTable>
                        </div>
                    </div>
                </div>

                <WidgetModal options={editComponentModelOptions} onRef={this.addComponent}>
                    <table>
                        <tbody>
                            <tr className="level">
                                <td>接口标题</td>
                                <td><Input defaultValue={editData.title} onChange={(value) => {this.inputOnchange(value, "ctitle")}} placeholder="请输入接口标题"/></td>
                            </tr>

                            <tr className="level">
                                <td>接口名称</td>
                                <td><Input defaultValue={editData.name} onChange={(value) => {this.inputOnchange(value, "cname")}} placeholder="请输入接口名称"/></td>
                            </tr>

                            <tr className="level">
                                <td>接口类型</td>
                                <td style={{paddingLeft:"6px"}}><WidgetSelect defaultValue={editData.type}  onSelect={this.onEditSelect} options={typeOptions}  data={typeData}></WidgetSelect></td>
                            </tr>

                            <tr className="level">
                                <td>接口路径</td>
                                <td><Input defaultValue={editData.description} onChange={(value) => {this.inputOnchange(value, "path")}} placeholder="请输入接口路径"/></td>
                            </tr>
                            <tr className="level">
                                <td style={{padding:"14px 3px"}}>反爬虫控制</td>
                                <td>
                                <RadioGroup name="radioList" defaultValue={editData.captchar} inline onChange={(value) => {this.inputOnchange(value, "cradios")}}>
                                    <Radio value={true}>启用</Radio>
                                    <Radio value={false}>停用</Radio>
                                </RadioGroup>
                                </td>
                            </tr>
                            <tr className="level">
                                <td>操作权限</td>
                                <td style={{width:"640px"}}>
                                <CheckboxGroup onChange={(value) => {this.inputOnchange(value, "coperation")}}
                                    inline
                                    name="checkboxList"
                                    defaultValue={editData.accessType}
                                    >
                                    <Checkbox value={1}>读</Checkbox>
                                    <Checkbox value={2}>写</Checkbox>
                                    <Checkbox value={4}>执行</Checkbox>
                                </CheckboxGroup>
                                </td>
                                <td>组件内容</td>
                                <td><Input defaultValue={editData.description} text="textarea" placeholder="请输入组件描述" onChange={(value) => {this.inputOnchange(value, "description")}}/></td>
                            </tr>
                        </tbody>
                    </table>
                </WidgetModal>
                <WidgetMessage options={messageOptions} onRef={this.messageRef} />
          </div>
        )
    }
}
export default Uims
